import React from "react";
import {
  EntityType,
  LicenseFreeSlotsRequest,
  LicenseFreeSlotsResponse,
} from "../../api/grpc/subscription/subscription";
import { useSubscriptionRequests } from "../../api/grpc/subscription/useSubscriptionRequests";
import { InputDescription } from "../../components/shared/InputDescription/InputDescription";
import { LoadingBox } from "../../components/shared/LoadingBox/LoadingBox";
import { useSubscriptionContext } from "../context/Subscription/SubscriptionContext";
import useGrpcQuery from "./useGrpcQuery";

export const useDefineLicense = ({
  type,
  adjustLeft,
  isLicensed,
}: {
  type: EntityType;
  adjustLeft?: boolean;
  isLicensed?: boolean;
}) => {
  const { licenseFreeSlots } = useSubscriptionRequests();
  const { hasUnlimitedUsers, subscriptionLoading } = useSubscriptionContext();

  const { loading, error, data, refetch } = useGrpcQuery<
    Omit<LicenseFreeSlotsRequest, "customerID" | "subscriptionID">,
    LicenseFreeSlotsResponse
  >({
    method: licenseFreeSlots,
    variables: {
      type: type,
    },
  });

  const defineLicenseNumber = () => {
    if (loading || (type === EntityType.USER && subscriptionLoading)) {
      return <LoadingBox minHeight={30} />;
    }

    if (error) {
      return (
        <InputDescription
          color="danger"
          title="Couldn't fetch licenses number!"
          className="InputDescription--switch"
        />
      );
    }

    const isUnlimited = type === EntityType.USER && hasUnlimitedUsers;
    const notAvailable =
      !isUnlimited && (!data?.quantity || data.quantity <= 0);

    if (isLicensed && notAvailable) {
      return <></>;
    }

    return (
      <InputDescription
        color={notAvailable ? "danger" : "theme"}
        title={
          isUnlimited
            ? "Unlimited"
            : notAvailable
            ? "No licenses left!"
            : `${data?.quantity} left`
        }
        className={`InputDescription--switch ${
          adjustLeft ? "InputDescription--switch--left" : ""
        }`}
      />
    );
  };

  return {
    defineLicenseNumber,
    refetch,
  };
};
